import { IconButton, Stack, Typography } from "@mui/material"
import { Dispatch, SetStateAction, useMemo, useState } from "react"
import { copyTextToClipboard } from "../../services/utilities/utility"
import { ContentCopyRounded, DeleteRounded } from "@mui/icons-material"

const ActivationCodeDomainsRow = ({
  domain,
  index,
  setCopyFeedbackOpen,
  currentDomainsWhiteList,
  setCurrentDomainsWhiteList,
  disabled,
}: {
  domain: string
  index: number
  setCopyFeedbackOpen: Dispatch<SetStateAction<boolean>>
  currentDomainsWhiteList: string[] | null
  setCurrentDomainsWhiteList: Dispatch<SetStateAction<string[] | null>>
  disabled?: boolean
}) => {
  // show delete icon
  const [showDelete, setShowDelete] = useState<boolean>(false)

  // if in currentDomainsWhiteList the current item appears more than once
  const isDuplicate = useMemo(
    () => currentDomainsWhiteList.filter((item) => item === domain).length > 1,
    [currentDomainsWhiteList]
  )

  return (
    <Stack
      direction="row"
      alignItems="center"
      onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => setShowDelete(false)}
      style={{
        width: "fit-content",
        height: 24,
        gap: showDelete ? 4 : 0,
        transition: "150ms",
      }}
    >
      <Stack gap={1} direction="row" alignItems="center">
        <Typography
          style={{ fontSize: "0.8rem", color: isDuplicate ? "red" : undefined }}
        >
          {domain}
        </Typography>
        {isDuplicate && (
          <Typography
            variant="overline"
            style={{
              color: "red",
              fontSize: "0.6rem",
              marginTop: 2,
            }}
          >
            Duplicate
          </Typography>
        )}
      </Stack>
      <IconButton
        style={{
          width: 24,
          padding: 0,
          height: 22,
          opacity: showDelete && !disabled ? 1 : 0,
          transition: "150ms",
        }}
        onClick={() => {
          copyTextToClipboard(domain)
          setCopyFeedbackOpen(true)
        }}
        disabled={disabled}
      >
        <ContentCopyRounded style={{ fontSize: 16 }} />
      </IconButton>
      <IconButton
        style={{
          width: 24,
          padding: 0,
          height: 22,
          opacity: showDelete && !disabled ? 1 : 0,
          transition: "150ms",
        }}
        onClick={() =>
          setCurrentDomainsWhiteList((current) => [
            ...current.slice(0, index),
            ...current.slice(index + 1),
          ])
        }
        disabled={disabled}
      >
        <DeleteRounded color="error" style={{ fontSize: 18 }} />
      </IconButton>
    </Stack>
  )
}

export default ActivationCodeDomainsRow
